<button
  type="button"
  class="document-action copy-action"
  (click)="openCopyDocumentDialog()"
>
  {{ 'ACTION.COPY' | translate }}
</button>
